import * as React from 'react';
import { useGetProductsBySkusExtended } from '@grandvisionhq/fun-search';
import { useProductPromotionEventContext } from '../../DataLayer/Contexts/ProductPromotionEventContext.js';
import { ProductListingGallery } from '../ProductListingGallery/ProductListingGallery.js';

const ProductBannerContainer = ({ skus , shouldCenterSlideItems  })=>{
    const { isLoading , listingProducts =[] , error  } = useGetProductsBySkusExtended({
        skus
    });
    const { trackImpression , trackInteraction  } = useProductPromotionEventContext();
    return /*#__PURE__*/ React.createElement(ProductListingGallery, {
        skus: skus,
        products: listingProducts,
        isLoading: Boolean(isLoading),
        hasError: Boolean(error),
        onProductImpression: trackImpression,
        onProductInteraction: trackInteraction,
        shouldCenterSlideItems: shouldCenterSlideItems
    });
};

export { ProductBannerContainer, ProductBannerContainer as default };
//# sourceMappingURL=ProductBannerContainer.js.map
